import { DEFAULT_RIGHT_OFFSET_BARS } from "../constants";

/** What the view does when a bar is added on the right. */
export const NEW_BAR_SCROLL = {
  // The view slides with the new bar, the right offset stays
  FOLLOW: "follow",
  // The view stays on the same bars, the new bar is added past them
  STAY: "stay",
};

/**
 * Autoscroll (D18 of the TV plan). On: the view follows new bars only while
 * the last bar is visible (with animation it scrolls evenly with time,
 * motion/viewFollow.js). Off, or when the last bar is off the screen: the
 * view is not touched, new bars go past the right edge.
 *
 * @param {object} timeScale
 * @param {boolean} isAutoscrollEnabled
 * @returns {boolean}
 */
export const isViewFollowingBars = (timeScale, isAutoscrollEnabled) =>
  isAutoscrollEnabled && timeScale.isLastBarVisible();

/**
 * What the view does with a new bar (isViewFollowingBars).
 *
 * @param {object} timeScale - before the bar is added
 * @param {boolean} isAutoscrollEnabled
 * @returns {string} NEW_BAR_SCROLL value
 */
export const resolveNewBarScroll = (timeScale, isAutoscrollEnabled) => {
  return isViewFollowingBars(timeScale, isAutoscrollEnabled) ? NEW_BAR_SCROLL.FOLLOW : NEW_BAR_SCROLL.STAY;
};

/**
 * View that shows the latest bars with the current zoom, as after opening
 * the chart.
 *
 * @param {object} timeScale - after the bar is added
 * @returns {{ barSpacing: number, rightOffset: number }} px, bars
 */
export const scrollToEndView = (timeScale) => ({
  barSpacing: timeScale.barSpacing,
  rightOffset: timeScale.clampRightOffset(DEFAULT_RIGHT_OFFSET_BARS),
});
